namespace GeniuzPOS.Product {
    export interface CsTasteRow {
        Id?: number;
        TasteId?: string;
        TasteName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsTasteRow {
        export const idProperty = 'TasteId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsTaste';
        export const lookupKey = 'Product.CsTaste';

        export function getLookup(): Q.Lookup<CsTasteRow> {
            return Q.getLookup<CsTasteRow>('Product.CsTaste');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:กลิ่น-รส:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:กลิ่น-รส:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:กลิ่น-รส:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:กลิ่น-รส:Modify';

        export declare const enum Fields {
            Id = "Id",
            TasteId = "TasteId",
            TasteName = "TasteName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
